// Clear search field instead of resetting it - when search bar is rendered
// on a search results page, the `value` field has search query value,
// and traditional reset will reset to original values.
document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.wp-block-search__reset' ).forEach( ( resetButton ) => {
		const searchInput = resetButton.parentNode.querySelector( 'input[type=search]' );

		if ( searchInput ) {
			resetButton.addEventListener( 'click', () => {
				searchInput.value = '';
				searchInput.focus();
			} );
		}
	} );
} );
